import { Image, StyleSheet } from "@react-pdf/renderer";
import { bool, string } from "prop-types";
import React from "react";
import logoTicketBG from "styles/images/logos/logoTicketBG.png";
import logoTicketFooter from "styles/images/logos/logoTicketFooter.png";

const ImagePDF = ({ imageFooter, imageBG, width, height, padding }) => {
    const styles = StyleSheet.create({
        logo: {
            width,
            height,
            objectFit: "cover",
            padding,
        },
    });

    return imageFooter || imageBG ? (
        <Image
            {...(imageFooter && { src: logoTicketFooter })}
            {...(imageBG && { src: logoTicketBG })}
            style={styles.logo}
        />
    ) : null;
};

ImagePDF.propTypes = {
    width: string,
    height: string,
    padding: string,
    imageFooter: bool,
    imageBG: bool,
};
ImagePDF.defaultProps = {
    width: "100%",
    height: "auto",
    padding: "1px",
    imageFooter: false,
    imageBG: false,
};

export default ImagePDF;
